(function () {
  function PaymentRequestDummy () {
    this.canMakePayment = () => Promise.reject(new Error('No PaymentRequest API'))
  }

  if (!('PaymentRequest' in window)) {
    window.PaymentRequest = PaymentRequestDummy
  }
})()
